import * as React from 'react';
import { Select } from '../../../../../Passenger/components/Field/Select/Select';
import { Field, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import { OrderDocumentType } from '@websky/graphql';
export const NAS_AND_TOURS_SINGLE_OPTION = 'nas&tours';
const DocumentsList = ({ everyPortPassengerIds, withEveryTravelServices }) => {
    var _a;
    const { t } = useTranslation('FlightInfoCard');
    const theme = useTheme('FlightInfoCard').TicketsModal;
    const passengerId = (_a = useFormState().values) === null || _a === void 0 ? void 0 : _a['passengers'];
    const documentsList = React.useMemo(() => {
        const documentsList = [
            {
                key: OrderDocumentType.All,
                value: t('All documents')
            },
            {
                key: OrderDocumentType.ItineraryReceipt,
                value: t('Itinerary Receipt')
            }
        ];
        const withEveryPortServices = (everyPortPassengerIds.length > 0 && passengerId === 'all') || everyPortPassengerIds.includes(passengerId);
        if (withEveryTravelServices && withEveryPortServices) {
            documentsList.push({
                key: NAS_AND_TOURS_SINGLE_OPTION,
                value: t('Airport Services & Tours')
            });
        }
        else if (withEveryPortServices) {
            documentsList.push({
                key: OrderDocumentType.NASTicket,
                value: t('Airport Services')
            });
        }
        else if (withEveryTravelServices) {
            documentsList.push({
                key: OrderDocumentType.EveryTravelTicket,
                value: t('Tours')
            });
        }
        return documentsList;
    }, [passengerId, everyPortPassengerIds, withEveryTravelServices]);
    return (React.createElement(Field, { name: "documents", defaultValue: OrderDocumentType.All, render: ({ input }) => (React.createElement(Select, { value: input.value, options: documentsList, name: "documents", label: "", onChange: input.onChange, onBlur: input.onBlur, className: theme.select })) }));
};
export default DocumentsList;
